import RMASistemasSite from './rmasistemas';
import './index.css';

function App() {
  return <RMASistemasSite />;
}

export default App;